import styled from 'styled-components';

export const PlaceHolder = styled.div``;

export const Content = styled.div`
  background-color: #10151a;
  position: relative;
  margin-left: 3ch;
  font-size: 12px;
  line-height: 1.2;
  border-radius: 0 10px 10px 0;
  box-sizing: border-box;
  textarea {
    box-sizing: border-box;
    display: block;
    border: 1px solid #3d4952;
    border-width: 1px 1px 1px 0;
    font-size: 12px;
    line-height: 1.2;
    resize: none;
    overflow: hidden;
    /* height: 512px; */
    /* width: 100%; */
    /* max-width: 646px; */
    padding: 0px 4px;
    word-break: break-all;
    white-space: nowrap;
    background: #10151a;
    margin: 0;
    /* position: absolute; */
    color: #e6eaec;
    caret-color: #47b972;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    border-radius: 0 10px 10px 0;
    &:focus {
      outline: none;
      border-color: #47b972;
    }
  }
`;
